<template>
  <!-- 加search表示进入搜索 -->
  <div id="g-layer" class="right">
    <!-- 顶部栏 -->
    <top-nav
      v-if="!$route.query.editionShare && !$route.meta.hideTopNav && !$route.meta.showDetailTopNav"
      :nav-list="navList"
      :current-item="currentTopNav"
      :static-nav-name="$route.meta.staticPageTitle"
    />
    <DetailTopNav
      v-if="!$route.query.editionShare && !$route.meta.hideTopNav && !!$route.meta.showDetailTopNav"
      :nav-list="navList"
      :current-item="currentTopNav"
      :static-nav-name="$route.meta.staticPageTitle"
    />
    <CommonPageTitle
      v-if="$route.meta.hideTopNav && $route.name !== 'publish'"
      :name="pageHeaderName"
      :title="pageHeaderTitle"
    />
    <SearchPanelNew class="SearchPanelNew" />
    <div class="main-content">
      <div
        v-if="!$route.query.editionShare && !$route.meta.hideRightNav"
        class="main-nav"
      >
        <ul
          ref="nav"
          class="nav g-nav"
          @touchstart="touchsideBar"
        >
          <!-- 侧边栏 -->
          <router-link
            v-for="sideBar in sideBarList"
            :key="sideBar.name"
            v-ptt="['btn', sideBar.name, sideBar.cname]"
            tag="li"
            :to="{ name: sideBar.targetTo }"
            :class="{
              nav_selected: sideBar.name === curBar,
            }"
          >
            <a href="javascript:;">
              <span>
                <img :src="sideBar.name === curBar? sideBar.actIcon : sideBar.icon" />
                <i>{{ sideBar.cname }}</i>
                <!-- 攻略tab 红点 -->
                <b
                  v-if="sideBar.name === 'walkthrough' && redPointWalkthrough"
                  class="red_point"
                  :class="{
                    on: redPointWalkthrough.num > 0,
                    num: redPointWalkthrough.type === 'number',
                  }"
                >{{ redPointWalkthrough.num }}</b>
                <!-- 福利tab 红点 -->
                <b
                  v-if="sideBar.name === 'welfare' && redPointWelfare"
                  class="red_point"
                  :class="{
                    on: redPointWelfare.num > 0,
                    num: redPointWelfare.type === 'number',
                  }"
                >{{ redPointWelfare.num }}</b>
                <!-- 我的tab 红点 -->
                <b
                  v-if="sideBar.name === 'mine' && redPointMine"
                  class="red_point"
                  :class="{
                    on: redPointMine.num > 0,
                    num: redPointMine.type === 'number',
                  }"
                >{{ redPointMine.num }}</b>
              </span>
            </a>
          </router-link>
        </ul>
      </div>
      <div class="g-content">
        <!-- 二级导航 -->
        <sub-nav
          v-if="subNavList && subNavList.length > 0"
          :nav-list="subNavList"
          :current-item="currentSubNav"
        />
        <!-- 三级导航 -->
        <third-nav
          v-if="thirdNavList && thirdNavList.length > 0"
          :nav-list="thirdNavList"
        />
        <router-view v-if="!$route.meta.keepAlive" />
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <Player v-if="$route.name === 'music-boutique' || $route.name === 'music-index'" />
      </div>
    </div>
    <FacePhotoAd v-if="$route.name === 'index' && isSDK" />
    <!-- <FacePhotoAd v-if="$route.name === 'index' && !isShowGuide && isSDK" /> -->
    <!-- <guide v-if="isShowGuide" :user-type="userType" /> -->
  </div>
</template>

<script>
import navList from './nav-list.js';
import TopNav from './TopNav.vue';
import DetailTopNav from './DetailTopNav.vue';
import ThirdNav from './ThirdNav.vue';
import FacePhotoAd from '@comps/face-photo-new/face-photo.vue';
import SubNav from './SubNav.vue';
import SearchPanelNew from '@comps/search/searchPanelNew.vue';
import Guide from './guide/index.vue';
import Player from '@views/tools/music/component/palyer/index.vue';
import { getURLParam, isArray, getEnv } from '@tencent/slug-function';
import { getSession } from '@utils/storage.js';
import { localByTime } from '@utils/storage-time.js';
import { getUserAttributeList } from '@api/ingame';
import CommonPageTitle from '@comps/CommonPageTitle';
const { isMSDK, isSlugSDK } = getEnv();
// import { getUserInfo } from '@api/comment';

export default {
  name: 'DefaultLayout',
  components: {
    FacePhotoAd,
    TopNav,
    SubNav,
    SearchPanelNew,
    ThirdNav,
    Guide,
    Player,
    CommonPageTitle,
    DetailTopNav,
  },
  data() {
    return {
      isShowGuide: false,
      userType: 1,
      isSDK: isMSDK || isSlugSDK,
      sideBarList: [
        {
          name: 'walkthrough',
          cname: '主页',
          targetTo: 'index',
          icon: 'https://gzhcos.qq.com/gp-ingame/img/nav1_no.png',
          actIcon: 'https://gzhcos.qq.com/gp-ingame/img/nav1_be.png',
        },
        {
          name: 'tools',
          cname: '工具',
          targetTo: 'map',
          icon: 'https://gzhcos.qq.com/gp-ingame/img/nav2_no.png',
          actIcon: 'https://gzhcos.qq.com/gp-ingame/img/nav2_be.png',
        },
        // {
        //   name: 'square',
        //   cname: '广场',
        //   targetTo: 'square',
        //   icon: 'https://gzhcos.qq.com/gp-ingame/img/nav3_no.png',
        //   actIcon: 'https://gzhcos.qq.com/gp-ingame/img/nav3_be.png',
        // },
        // {
        //   name: 'welfare',
        //   cname: '福利',
        //   targetTo: 'index-calendar',
        //   icon: 'https://gzhcos.qq.com/gp-ingame/img/nav4_no.png',
        //   actIcon: 'https://gzhcos.qq.com/gp-ingame/img/nav4_be.png',
        // },
        // {
        //   name: 'mine',
        //   cname: '我的',
        //   targetTo: 'mine',
        //   icon: 'https://gzhcos.qq.com/gp-ingame/img/nav5_no.png',
        //   actIcon: 'https://gzhcos.qq.com/gp-ingame/img/nav5_be.png',
        // },
      ],
    };
  },
  computed: {
    // 普通标题页面底文案
    pageHeaderName() {
      return this.$store.getters.getCommonPageName;
    },
    pageHeaderTitle() {
      return this.$store.getters.getCommonPageTitle;
    },

    // 攻略模块红点
    redPointWalkthrough() {
      return this.$store.getters.redPointWalkthroughSum;
    },
    // 福利模块红点
    redPointWelfare() {
      return this.$store.getters.redPointWelfareSum;
    },
    // 我的模块红点
    redPointMine() {
      return this.$store.getters.redPointMineSum;
    },
    // 当前侧边栏active
    curBar() {
      return this.$route.meta.sideBar;
    },
    // 左侧导航list
    navList() {
      return navList[`${this.curBar}_navs`];
    },
    // 导航匹配，获取当前激活的一级导航
    currentTopNav() {
      if (!this.navList) return {};
      return this.findNav(this.navList);
    },
    currentSubNav() {
      if (!this.currentTopNav) return {};
      if (!this.currentTopNav.children) return {};
      return this.findNav(this.currentTopNav.children);
    },
    // 二级导航list
    subNavList() {
      if (this.currentTopNav) {
        return this.currentTopNav.children || [];
      }
      return [];
    },
    thirdNavList() {
      if (this.currentSubNav) {
        return this.currentSubNav.children || [];
      }
      return [];
    },
    hasRedDot() {
      return this.completeStep > this.step;
    },
  },
  created() {
  },

  mounted() {
    this.$nextTick(() => {
      // 修复vivoX9未显示二级标题，页面上移
      if (document.querySelector('#app')) {
        setTimeout(() => {
          document.querySelector('#app').scrollTop = 0;
        }, 600);
      }
    });
    if (this.$route.name === 'index') {
      // this.getUserType();
      this.getRoadVisit();
    }
  },
  methods: {
    touchsideBar() {
      if (this.$route.name === 'edition-vote') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        document.body.scrollTop = 0;
        document.querySelector('#app').scrollTop = 0;
      }
    },
    findNav(nav) {
      if (!(nav instanceof Array)) {
        return;
      }
      const curNav = nav.find((childNav) => {
        if (childNav.targetRouterName === this.$route.name) {
          return true;
        }
        const navHasChildren = childNav.children && childNav.children.length > 0;
        if (!navHasChildren) return false;
        return this.findNav(childNav.children);
        if (curNav !== undefined) {
          return true;
        }
        return false;
      });
      return curNav;
    },

    getRoadVisit() {
      const openid = getURLParam('openid', getSession('tokenParams'));
      getUserAttributeList(openid).then(({ data: res }) => {
        if (isArray(res.attrs)) {
          const info = res.attrs.find((attr) => {
            if (attr.key === 'successRoadVisit' && attr.b) {
              return true;
            }
            return false;
          });
          if (!info) {
            this.$router.push({ path: '/gp/road' });
          }
        }
      })
        .catch((err) => {
          window.Sentry.captureMessage(new Error(`getRoadVisit, ${JSON.stringify(err)}`));
        });
    },

    getUserType() {
      const openid = getURLParam('openid', getSession('tokenParams'));
      getUserAttributeList(openid).then(({ data: res }) => {
        if (isArray(res.attrs)) {
          const info = res.attrs.find((attr) => {
            if (attr.key === 'activeState') {
              return true;
            }
            return false;
          });
          if (!info) {
            return;
          }

          // 1 新用户。 2 老用户 。 3 回流用户
          if ((info.d === 1 || info.d === 3) && !Boolean(localByTime.get('hasSeenGuide'))) {
            this.userType = info.d;
            this.isShowGuide = true;
          }
        }
      })
        .catch((err) => {
          window.Sentry.captureMessage(new Error(`getUserType,${JSON.stringify(err)}`));
        });
    },
  },
};
</script>

<style lang="scss">
@import "@scss/default/nav.scss";
@import '@scss/var.scss';

.g-content {
  transform: translate(0, 0);
}

// .point-answer {
//   position: absolute;
//   width: 0.2rem;
//   height: 0.2rem;
//   background: #f52b0a;
//   border-radius: 100%;
//   top: -0.07rem;
//   right: -0.07rem;
// }

.red_point {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  background-color: #f93501;
  display: none;
  position: absolute;
  right: 7%;
  top: 5%;
  color: transparent;
  font-size: 0.14rem;
  text-align: center;
  line-height: 0.18rem;
}

.red_point.on {
  display: block;
}

.red_point.num {
  display: none;
  color: #fff;
}

.red_point.num.on {
  display: block;
}

.datatips {
  font-size: 0.24rem;
  color: #212124;
  //opacity: 0.4;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  top: 73.1%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: "";
    background: url(../../assets/img/icon/nothing.png) no-repeat center/cover;
    width: 2.95rem;
    height: 2.46rem;
    position: absolute;
    top: -2.7rem;
    transform: translateX(-9%);
  }
}
@include min216 {
  .datatips {
    top: 81%;
  }
}
</style>
